export const mainConstants = {
  MAIN_LOAD_REQUEST: 'PTL_MEMBER_APP_LOAD_REQUEST',
  MAIN_LOAD_SUCCESS: 'PTL_MEMBER_APP_LOAD_SUCCESS',
  MAIN_LOAD_FAILURE: 'PTL_MEMBER_APP_LOAD_FAILURE',

  /** 디바이스 아이디 없으면 insert */
  APP_ACCESS_LOAD_REQUEST: 'APP_ACCESS_LOAD_REQUEST',
  APP_ACCESS_LOAD_SUCCESS: 'APP_ACCESS_LOAD_SUCCESS',
  APP_ACCESS_LOAD_FAILURE: 'APP_ACCESS_LOAD_FAILURE',
}
